import { convertIntoLakh } from "../UtilityComponents/UtilityFunction";

function CompareInvestmentPlans({ close, Quotes }) {
    const maxQuote = Quotes.reduce((accu, curElem, curInd, arr) => {
        return curElem.MaturityBenefit > accu.MaturityBenefit ? curElem : accu;
    }, Quotes[0]);

   
    return (
        <>
            <div className="Compare InvestmentLoginPage">
                <div className="CalculatorHead RetirementCalc Compare">
                    <h2>Comparison of 100% Guaranteed Plans with RD & FD</h2>
                    <button className="clsBtn" onClick={close}>
                        <img src={require("../../Investment/Cross.svg").default} alt="" />
                    </button>
                </div>
                <div className="Compareheading">
                    <ul>
                        <li></li>
                        <li><strong>100% Guaranteed Plans</strong></li>
                        <li><strong>Recurring Deposit (RD)</strong></li>
                        <li><strong>Fixed Deposit (FD)</strong></li>
                    </ul>
                </div>
                <div className="tablesec">
                    <table className="table tabborder table-striped align-middle">
                        <thead>
                            <tr>
                                <td className="lessWidth"></td>
                                <th><strong>100% Guaranteed Plans</strong></th>
                                <th><strong>Requiring Deposit (RD)</strong></th>
                                <th><strong>Fixed Deposit (FD)</strong></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="lessWidth"><strong>Total Investment</strong></td>
                                <td>₹{convertIntoLakh(maxQuote?.TatalInvestmentAmount)}</td>
                                <td>₹{convertIntoLakh(maxQuote?.TatalInvestmentAmount)}</td>
                                <td>₹{convertIntoLakh(maxQuote?.TatalInvestmentAmount)}</td>
                            </tr>
                            <tr>
                                <td className="lessWidth"><strong>Return</strong></td>
                                <td>₹{convertIntoLakh(maxQuote?.MaturityBenefit)}</td>
                                <td>₹{convertIntoLakh(maxQuote?.RecurringDeposit?.maturityAmount)} <p>(@ {maxQuote?.RecurringDeposit?.interestRate})</p></td>
                                <td>₹{convertIntoLakh(maxQuote?.FixedDeposit?.maturityAmount)} <p>(@ {maxQuote?.FixedDeposit?.interestRate})</p></td>
                            </tr>
                            <tr>
                                <td className="lessWidth"><strong>Returns after Tax</strong></td>
                                <td>₹{convertIntoLakh(maxQuote?.MaturityBenefit)}</td>
                                <td>₹{convertIntoLakh(maxQuote?.RecurringDeposit?.returnAfterTax)}<p>(@ {maxQuote?.RecurringDeposit?.returnAfterTaxPercent})</p></td>
                                <td>₹{convertIntoLakh(maxQuote?.FixedDeposit?.returnAfterTax)}<p>(@ {maxQuote?.FixedDeposit?.returnAfterTaxPercent})</p></td>
                            </tr>
                            <tr>
                                <td className="lessWidth"><strong>Death Benefit</strong></td>
                                <td>₹{convertIntoLakh(maxQuote?.DeathBenefit)}</td>
                                <td>None</td>
                                <td>None</td>
                            </tr>
                            <tr>
                                <td className="lessWidth"><strong>Nature</strong></td>
                                <td>These plans are typically offered by insurance companies or financial institutions and provide both investment and insurance components.</td>
                                <td>RDs allow individuals to save small amounts regularly, building a corpus over time.</td>
                                <td>FDs are savings instruments offered by banks and financial institutions where individuals deposit a lump sum for a fixed tenure at a predetermined interest rate.</td>
                            </tr>
                            <tr>
                                <td className="lessWidth"><strong>Returns</strong></td>
                                <td>Offer guaranteed returns on the invested amount, ensuring that you receive the promised amount at maturity.</td>
                                <td>Offer interest on monthly contributions, which is typically lower than FD rates.</td>
                                <td>Provide fixed returns, with interest rates declared at the time of investment.</td>
                            </tr>
                            <tr>
                                <td className="lessWidth"><strong>Insurance</strong></td>
                                <td>Include an insurance component, providing financial protection to the policyholder and beneficiaries.</td>
                                <td>No insurance coverage is provided with RDs; they are savings instruments.</td>
                                <td>No insurance component is included in FDs; they are pure investment instruments.</td>
                            </tr>
                            <tr>
                                <td className="lessWidth"><strong>Liquidity</strong></td>
                                <td>Generally have limited flexibility in terms of premium payments and withdrawals.</td>
                                <td>Provide flexibility to invest a fixed amount at regular intervals.</td>
                                <td>Generally less liquid than RDs; early withdrawal might attract penalties.</td>
                            </tr>
                            <tr>
                                <td className="lessWidth"><strong>Commitment Period</strong></td>
                                <td>Often require a longer commitment period, which can vary based on the plan.</td>
                                <td>Generally allow contributions over a chosen period.</td>
                                <td>Have a fixed tenure chosen by the depositor.</td>
                            </tr>
                            <tr>
                                <td className="lessWidth"><strong>Tax Benefits</strong></td>
                                <td>Some plans may offer tax benefits under applicable tax laws.</td>
                                <td>Interest earned is taxable; returns may vary based on applicable tax laws.</td>
                                <td>Interest earned is taxable at the individual's applicable tax rate.</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="FactorTC">
                        <h4>Factors to Consider:</h4>
                        <ul>
                            <li>Guaranteed plans provide guaranteed returns and insurance benefits, while FDs and RDs offer fixed interest rates but no insurance coverage.</li>
                            <li>FDs and RDs may have withdrawal restrictions, while guaranteed plans offer liquidity options but with some restrictions.</li>
                            <li>Guaranteed plans offer both investment and insurance benefits, making them suitable for risk coverage.</li>
                            <li>Tax implications vary for each option and depend on your prevailing tax laws.</li>
                            <li>Consider the desired investment horizon and the flexibility to withdraw or continue the investment.</li>
                        </ul>
                        <span className="FCText">The choice among these options depends on your financial goals, risk tolerance, liquidity needs, and tax considerations. Consulting with a financial advisor can help align your investment strategy with your specific circumstances and objectives.</span>
                      {/*  <div className="FactorTC-btn">
                            <button className="FC-btn" onClick={close}><span className="FC-btn-text">Got It</span></button>
                        </div>*/}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompareInvestmentPlans;
